import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { KostikService } from 'src/app/services/kostik.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-kostik-factor',
  templateUrl: './create-kostik-factor.component.html',
  styles: [
  ]
})
export class CreateKostikFactorComponent implements OnInit {

  public kostikFactorForm = this.fb.group({
    factor:[''],
    dimension:[''],
    score:[0],
    description:['']
  })

  public factor;
  public dimension;
  public lowPositive;
  public lowNegative;
  public midPositive;
  public midNegative;
  public highPositive;
  public highNegative;
  public interpretations=[];

  constructor(private fb:FormBuilder, private kostikService:KostikService) { }

  ngOnInit(): void {
    this.kostikService.getRanks().subscribe(
      resp=>{
        this.interpretations = resp;
      },
      err=>console.log(err)
    )
  }

  register(){
    this.kostikService.createFactor(this.kostikFactorForm.value).subscribe(
      resp=>{
        let timerInterval
        Swal.fire({
          title: 'Factor creado',
          html: '',
          timer: 1000,
          timerProgressBar: true,
          willOpen: () => {
            Swal.showLoading()
          },
          onClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {

          if (result.dismiss === Swal.DismissReason.timer) {
            
          }
        })
        this.kostikFactorForm.reset();
      },
      err=>{
        console.log(err);
      }
    )
  }

  reset(){
    this.kostikFactorForm.reset();
  }

  createInterpretation(){
    
    this.kostikService.updateRanks({

      factor:this.factor,
      dimension:this.dimension,
      lowPositive:this.lowPositive,
      lowNegative:this.lowNegative,
      midPositive:this.midPositive,
      midNegative:this.midNegative,
      highPositive:this.highPositive,
      highNegative:this.highNegative,

    }).subscribe(
      resp=>{
        window.location.reload();
      },
      err=>console.log(err)
    )
  }

}
